<template>
  <div class="top-comment" @click.stop="onClick">
    <div @click.stop="showUserDetails(comment)">
      <div class="top-comment__avatar">
        <account-social-avatar
          :avatar="comment.avatarImage"
          :showProgress="false"
          :percentage="100"
          :showEdit="false"
          theme="markets"
        >
        </account-social-avatar>
      </div>
      <div class="top-comment__info">
        <div class="top-comment__name">
          {{ comment.userName }}
        </div>
        <div class="top-comment__active" v-if="comment.profitablePredictions">
          {{ traderLevelDisplay(comment) }}
        </div>
      </div>
    </div>
    <div v-if="comment.marketTitle" v-html="comment.marketTitle" class="top-comment__market"></div>
    <div ref="text" v-html="comment.comment" class="top-comment__comment"></div>
  </div>
</template>

<script src="./top-comment.js"></script>
<style src="./top-comment.scss" lang="scss"></style>
